import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { LucideAngularModule, MapPin } from 'lucide-angular';
import { InfoLineComponent } from '../info-line/info-line.component';

@Component({
  selector: 'app-location-info-line',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, InfoLineComponent],
  templateUrl: './location-info-line.component.html',
})
export class LocationInfoLineComponent {
  location = input.required<string>();
  additionalClasses = input<string>();

  protected readonly icon = MapPin;
}
